//Alert Options
export const DROPDOWN_ALERTS_OPTIONS = {
    timeout: 5000, //ms
    position: 'top center',
}
